import DetailCardBody from '@/common/components/DetailCard/DetailCardBody';
import DetailCardItems from '@/common/components/DetailCard/DetailCardItems';
import MainDetailCard from '@/common/components/DetailCard/MainDetailCard';
// import useInfinityScroll from '@/common/hooks/useInfinityScroll';
import LoadingPage from '@/common/pages/LoadingPage';
import StatusTransitionAction from '@/modules/FileDetail/components/statusTransition/statusTransitionAction/StatusTransitionAction.tsx';
import StatusTransitionHeader from '@/modules/FileDetail/components/statusTransition/statusTransitionHeader/StatusTransitionHeader.tsx';
import { statusTransitionQueryOptions } from '@/modules/FileDetail/queries/statusTransition/statusTransitionQueryOptions.ts';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

const StatusTransitionList = () => {
  const { id } = useParams();

  const {
    data: statusData,
    isError,
    isPending,
    // fetchNextPage,
  } = useQuery({
    ...statusTransitionQueryOptions(id || ''),
    enabled: !!id, // ✅ فقط وقتی id موجود است کوئری اجرا می‌شود
  });
  // const { observerRefCallback } = useInfinityScroll(fetchNextPage);

  if (isError) {
    return <></>;
  }
  if (isPending) {
    return <LoadingPage />;
  }

  return statusData?.map((file, index) => (
    <MainDetailCard key={file.id}>
      <StatusTransitionHeader index={index + 1} statusDate={file.status_date} />
      <DetailCardBody>
        <DetailCardItems
          backgroundColor="purple-3"
          items={file?.detailCardItems ?? []}
        />
      </DetailCardBody>
      <StatusTransitionAction
        action={file?.action}
        description={file?.description}
      />
    </MainDetailCard>
  ));
};

export default StatusTransitionList;
